import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import useLogout from "../../hooks/useLogout";
import { useForm } from "react-hook-form";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  TooltipComponent,
} from "../../components/Component";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import { Badge } from "reactstrap";
// import { listhospitalAPI, updatehospitalAPI } from "../../api/pahrmacy";
import { toast } from "react-toastify";
import { BASE_URL_IMG } from "../../assets/constants";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import { useNavigate } from "react-router";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import { listHospitalAPI } from "../../api/dropdown";

const HospitalList = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
    },
  });
  const navigate = useNavigate();
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);

  const [column, setColumns] = useState([
    {
      name: "Hospital Name",
      selector: (row) => row?.name,
      sortable: true,
      wrap: true
      // width: "180px",
    },

    {
      name: "Contact Person",
      selector: (row) => row?.contactPerson,
      sortable: true,
      wrap: true,
      // width: "120px",
    },
    {
      name: "Mobile",
      selector: (row) => row?.mobile,
      sortable: true,
      // width: "120px",
    },
    //   {
    //     name: "Alternate Contact",
    //     selector: (row) => row?.alternateContactNumber,
    //     sortable: true,
    //     width: "120px",
    //   },
    //   {
    //     name: "Hospital Type",
    //     selector: (row) => row?.hospitalType,
    //     sortable: true,
    //     width: "150px",
    //   },
       {
      name: "Email",
      selector: (row) => row?.email,
      sortable: true,
      // width: "150px",
    },
    // {
    //   name: "Registration Number",
    //   selector: (row) => row?.registrationNumber,
    //   sortable: true,
    //   // width: "150px",
    // },
    // {
    //   name: "Address",
    //   selector: (row) =>
    //     `${row?.addressLine1 || ""}, ${row?.addressLine2 || ""}, ${row?.district || ""}, ${row?.state || ""}, ${row?.country || ""} - ${row?.pincode || ""}`,
    //   sortable: true,
    //   wrap: true,
    //   // width: "250px",
    // },
{
  name: "Address",
  sortable: true,
  wrap: true,
  cell: (row) => {
    const fullAddress = `${row?.addressLine1 || ""}, ${row?.addressLine2 || ""}, ${row?.district || ""}, ${row?.state || ""}, ${row?.country || ""} - ${row?.pincode || ""}`;

    return (
      <div
        title={fullAddress}
        style={{
          maxWidth: "150px",
            // whiteSpace: "nowrap",
            overflow: "hidden",
            // textOverflow: "ellipsis",
            cursor: "pointer",
        }}
      >
       {truncateByWords(fullAddress, 2)} 
      </div>
    );
  },
},



    {
      name: "KYC Status",
      selector: (row) => row?.kyc_status,
      cell: (row) => (
        <Badge
          className="text-capitalize"
          color={`${row.kyc_status === "pending"
              ? "outline-warning"
              : row.kyc_status === "Approved"
                ? "outline-primary"
                : row.kyc_status === "In Review"
                  ? "outline-info"
                  : "outline-danger"
            }`}
        >
          {row.kyc_status}
        </Badge>
      ),
      sortable: true,
      // width: "100px",
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>,
      sortable: true,
      width: "100px",
    },
    {
      name: "Action",
      // width: "120px",
      cell: (row) => (
        <>
          {" "}
          {row?.kyc_status == "Approved" ? null : (
            <>
              <Button
                outline
                style={{ width: "50px" }}
                color={`primary`}
                size={`xs`}
                className={`me-1 my-1 d-flex flex-column m-1 justify-content-center align-items-center`}
                id={`app-${row?.id}`}
                onClick={() => handleShowDetails(row)}
              >
                {" "}
                <Icon name="box" />
              </Button>
              <TooltipComponent iconClass="card-hint" direction="top" id={`app-${row?.id}`} text="View and Approval" />
              <Button
                id={`app-${row?.id}`}
                className="mx-1"
                outline
                color="warning"
                size="xs"
                onClick={() => handleEdit(row)}
              >
                <Icon name="edit" />
              </Button>
            </>
          )}
        </>
      ),
    },
    //   {
    //     name: "Step",
    //     selector: (row) => row?.step,
    //     sortable: true,
    //     width: "80px",
    //   },
    //   {
    //     name: "Created At",
    //     selector: (row) => new Date(row?.createdAt).toLocaleString(),
    //     sortable: true,
    //     width: "180px",
    //   },
    //   {
    //     name: "Updated At",
    //     selector: (row) => new Date(row?.updatedAt).toLocaleString(),
    //     sortable: true,
    //     width: "180px",
    //   },
  ]);

  const handleEdit = (row) => {
    console.log("rowEdit", row);
    navigate(`/hospital-registration/hospital-basic-details`, { state: { hospitalid: row?.id, mode: "Edit" } });
  };
  const handleShowDetails = (row) => {
    console.log("rowEdit", row);
    navigate("/hospitalApprove", { state: { hospitalId: row?.id, mode: "Approval" } });
  };

  const handleImageOpenPreview = (row, name) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  useEffect(() => {
    gethospitalList();
  }, []);

  const gethospitalList = () => {
    setValue("isLoading", true);
    listHospitalAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res.data.status === true) {
          toast.clearWaitingQueue();
          setData(res.data.data);
          resetForm();
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setData([]);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      })
        .finally(() => {
        setValue("isLoading", false);
      });
  };
  const resetForm = () => { };
  

    const truncateByWords = (text = "", wordLimit = 5) => {
    if (!text) return "";

    const words = text.trim().split(/\s+/);
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + " ..."
      : text;
  };


  return (
    <>
      <Head title={"hospital List"} />
      <Content>
        <BlockHead size={`sm`} className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Hospital"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  // onClick={() =>  navigate("/hospital-detail")}
                  onClick={() => navigate("/hospital-registration/hospital-basic-details", { state: { mode: "Add" } })}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block className="pt-0">
          <MyDataTable title={"Hospital List"} isLoading={isLoading} columns={column} data={data || []} />
        </Block>
      </Content>
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        // onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        data={watch("selectedRow")}
      />
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
    </>
  );
};

export default HospitalList;
